import styled, { css } from 'styled-components';

import { xdlColorBackground } from '@xing-com/tokens';

export const ShareContainer = styled.div<{
  $tabbed?: boolean;
  $borderless?: boolean;
}>`
  ${(props) =>
    !props.$borderless &&
    css`
      padding: 1rem;
      background: ${xdlColorBackground};
      min-height: 100vh;
    `};

  ${({ $tabbed }) =>
    !$tabbed &&
    css`
      & > div > button[class^='share-tab-view-styles__Button'] {
        display: none;
      }

      & > div > hr[class^='divider-styles__Divider'] {
        display: none;
      }
    `}
`;
